import { N_UPGRADES, APP_WIDTH, APP_HEIGHT } from "./constants"
import {
  Container,
  Assets,
  AnimatedSprite,
  Texture,
  Text,
  TextStyle,
} from "pixi.js"

const UPGRADE_MULTISHOT = 0
const UPGRADE_DMG_UP = 1
const UPGRADE_HP_UP = 2
const UPGRADE_PROJECTILE_SPEED = 3
const UPGRADE_SHOT_FREQUENCY = 4
const UPGRADE_STAMINA = 5
const UPGRADE_SPEED = 6
const N_UPGRADE_TYPES = 7

const style = new TextStyle({
  fontFamily: "monospace",
  fontSize: 16,
  fill: { color: "#fff" },
})

const headingStyle = new TextStyle({
  fontFamily: "monospace",
  fontSize: 32,
  fill: { color: "#fff" },
})

export async function Upgrades({ app, player }) {
  const upgrades = new Container()

  await Assets.load("res/upgrades.json")
  await Assets.load("https://pixijs.com/assets/bitmap-font/desyrel.xml")

  const frames = [...Array(2)].map((_, i) => Texture.from(`upgrades ${i}`))

  const title = new Text({
    text: "LEVEL UP",
    style: headingStyle,
  })
  title.anchor.set(0.5, 0.5)
  title.x = APP_WIDTH / 2
  title.y = APP_HEIGHT / 2 - 135
  upgrades.addChild(title)

  const subtitle = new Text({
    text: "Bet you wish you were wiser, kid...",
    style,
  })
  subtitle.anchor.set(0.5, 0.5)
  subtitle.x = APP_WIDTH / 2
  subtitle.y = APP_HEIGHT / 2 - 100
  upgrades.addChild(subtitle)

  let upgradeSlots = []

  const closeUpgrades = () => {
    upgrades.renderable = false
    app.paused = false
  }

  for (let i = 0; i < N_UPGRADES; ++i) {
    const upgrade = new AnimatedSprite(frames)
    upgrade.anchor.set(0.5, 0.5)
    upgrade.x =
      APP_WIDTH / 2 -
      (150 - 10) * Math.floor(N_UPGRADES / 2) +
      (150 + 10) * i -
      20
    upgrade.y = APP_HEIGHT / 2
    upgrade.currentFrame = 0
    upgrade.upgradeType = 0

    const textApart = 20

    upgrade.title = new Text({
      text: "",
      style,
    })
    upgrade.title.anchor.set(0.5, 0)
    upgrade.title.x = upgrade.x
    upgrade.title.y = upgrade.y - textApart / 2

    upgrade.description = new Text({
      text: "",
      style,
    })
    upgrade.description.anchor.set(0.5, 0)
    upgrade.description.x = upgrade.x
    upgrade.description.y = upgrade.y + textApart / 2

    upgradeSlots.push(upgrade)
    upgrades.addChild(upgrade.title)
    upgrades.addChild(upgrade.description)
    upgrades.addChild(upgrade)

    upgrade.on("pointerdown", () => {
      switch (upgrade.upgradeType) {
        case UPGRADE_MULTISHOT:
          ++player.nProjectiles
          break
        case UPGRADE_DMG_UP:
          ++player.damage
          break
        case UPGRADE_HP_UP:
          player.maxHealth += 20
          break
        case UPGRADE_PROJECTILE_SPEED:
          ++player.projectileSpeed
          break
        case UPGRADE_SHOT_FREQUENCY:
          player.reloadTime = Math.max(player.reloadTime - 30, 0)
          break
        case UPGRADE_STAMINA:
          player.maxStamina += 10
          break
        case UPGRADE_SPEED:
          player.speed += 0.01
          break
      }

      player.health = player.maxHealth
      player.stamina = player.maxStamina
      player.expendedStamina = false

      closeUpgrades()
    })
    upgrade.on("pointerenter", () => {
      upgrade.currentFrame = 1
      document.body.style.cursor = "pointer"
    })
    upgrade.on("pointerleave", () => {
      upgrade.currentFrame = 0
      document.body.style.cursor = "default"
    })
    upgrade.eventMode = "static"
  }

  const openUpgrades = () => {
    // Randomize upgrades
    let usedUpgradeTypes = []
    upgradeSlots.forEach((upgrade) => {
      for (;;) {
	upgrade.upgradeType = Math.floor(Math.random() * N_UPGRADE_TYPES)
	if (!usedUpgradeTypes.includes(upgrade.upgradeType))
	  break
      }
      
      usedUpgradeTypes.push(upgrade.upgradeType)
      switch (upgrade.upgradeType) {
        case UPGRADE_MULTISHOT:
          upgrade.title.text = "MULTISHOT"
          upgrade.description.text = "+1 bullet"
          break
        case UPGRADE_DMG_UP:
          upgrade.title.text = "DMG UP"
          upgrade.description.text = "+1 dmg"
          break
        case UPGRADE_HP_UP:
          upgrade.title.text = "HP UP"
          upgrade.description.text = "+20 hp"
          break
        case UPGRADE_PROJECTILE_SPEED:
          upgrade.title.text = "BULLET SPEED"
          upgrade.description.text = "+1 speed"
          break
        case UPGRADE_SHOT_FREQUENCY:
          upgrade.title.text = "RELOAD TIME"
          upgrade.description.text = "-30 ms"
          break
        case UPGRADE_STAMINA:
          upgrade.title.text = "STAMINA UP"
          upgrade.description.text = "+10 stamina"
          break
        case UPGRADE_SPEED:
          upgrade.title.text = "SPEED UP"
          upgrade.description.text = "+1 speed"
          break
      }
    })

    upgrades.renderable = true
    app.paused = true
  }

  closeUpgrades()

  return {
    upgrades,
    openUpgrades,
    closeUpgrades,
  }
}
